export default __webpack_public_path__ + "static/media/english-to-german-screenshot-01.4ef7f34f.png";